import { jsx as r } from "react/jsx-runtime";
import { components as e } from "react-select";
function i(o) {
  return (n) => {
    const { children: t, ...u } = n;
    return /* @__PURE__ */ r(e.Option, { ...u, children: o ? /* @__PURE__ */ r("span", { "data-notranslate": !0, children: t }) : t });
  };
}
function a({
  injectedChildren: o,
  dataNoTranslate: n
}) {
  return (t) => {
    const u = () => n ? /* @__PURE__ */ r("span", { "data-notranslate": !0, children: t.children }) : t.children;
    return /* @__PURE__ */ r(e.SingleValue, { ...t, children: o ? o(u()) : u() });
  };
}
function c(o) {
  return (n) => /* @__PURE__ */ r(e.DropdownIndicator, { ...n, children: o });
}
function m({
  dataNoTranslate: o,
  children: n
}) {
  return {
    SingleValue: a({
      injectedChildren: n == null ? void 0 : n.singleValue,
      dataNoTranslate: o
    }),
    Option: i(o),
    DropdownIndicator: c(
      n == null ? void 0 : n.indicator
    )
  };
}
export {
  m as buildCustomDropdownComponents,
  c as customDropdownIndicator,
  i as customOption,
  a as customSingleValue
};
